import { PortalRightsGrouped } from '@skf/bt-wind-rail-commonlibrary/dist/types/AccountPageData';

export interface UserSettings {
  webFeatures: UserWebFeatures[];
  status?: number;
}

export enum UserWebFeatures {
  TURBINE_OVERVIEW_READ = 'Turbine_Overview_Read',

  REPORT_FAULT_CREATE = 'Report_Fault_Create',
  REPORT_FAULT_READ = 'Report_Fault_Read',
  REPORT_FAULT_UPDATE = 'Report_Fault_Update',
  REPORT_FAULT_DELETE = 'Report_Fault_Delete',

  REPORT_FEEDBACK_CREATE = 'Report_Feedback_Create',
  REPORT_FEEDBACK_READ = 'Report_Feedback_Read',
  REPORT_FEEDBACK_UPDATE = 'Report_Feedback_Update',
  REPORT_FEEDBACK_DELETE = 'Report_Feedback_Delete',

  ANALYTICS_INSIGHTS_READ = 'Analytics_Insights_Read',
  ANALYTICS_RELIABILITY_READ = 'Analytics_Reliability_Read',
  ANALYTICS_SENSORROLLER_READ = 'Analytics_SensorRoller_Read',
  ANALYTICS_AI_READ = 'Analytics_AI_Read',
  SKF_ANALYTICS_READ = 'SKF_Analytics_Read',

  WORK_ORDERS_READ = 'Work_Orders_Read',

  SUPPLY_CHAIN_READ = 'SupplyChain_Read',

  ROLE_MANAGEMENT_ACCESS = 'RoleManagement_Access',
}

export interface AccountSettings {
  userName: string;
  accountLanguage: string[];
  accountCurrency: string[];
  preferredLanguage: string;
  preferredCurrency: string;
  isSKF: boolean;
  userAccess: PortalRightsGrouped[];
}
